import * as React from 'react';
import Input from '../../../../Input/Input';
import { MaskedInputProps } from 'react-text-mask';
import { InputBaseComponentProps } from '@mui/material/InputBase';
import { Datepicker } from '../../../../Datepicker';
import { Dialog } from '@mui/material';
import { DateMaskedInput } from '../../../../DateMaskedInput/DateMaskedInput';

interface DatePickerProps {
	openDate?: Date;
	onSelect: (date: Date) => void;
	selectedDates?: Date[];
	onCloseDatePicker: () => void;
	isOpenDatePicker: boolean;
	minDate?: Date;
	maxDate?: Date;
}

export interface DateFieldProps {
	label?: string;
	value?: string;
	name?: string;
	className?: string;
	labelClassName?: string;
	labelShrinkClassName?: string;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
	error?: string;
	disabled?: boolean;
	shrink?: boolean;
	focused?: boolean;
	variant?: 'standard' | 'filled' | 'outlined';
	absoluteHintPosition?: boolean;
	datePicker?: DatePickerProps;
}

const DateMaskedInputInner = React.forwardRef<HTMLElement, MaskedInputProps & InputBaseComponentProps>((props, ref) => (
	<DateMaskedInput {...props} ref={ref} placeholder="__.__.____" guide={false} />
));

export const DateField: React.FunctionComponent<DateFieldProps> = props => {
	return (
		<>
			<Input
				label={props.label}
				value={props.value}
				name={props.name}
				className={props.className}
				labelClassName={props.labelClassName}
				labelShrinkClassName={props.labelShrinkClassName}
				focused={props.focused}
				TextFieldProps={{
					onChange: props.onChange,
					onBlur: props.onBlur,
					error: !!props.error,
					helperText: props.error,
					disabled: props.disabled,
					type: 'tel'
				}}
				shrink={props.shrink}
				variant={props.variant}
				inputComponent={DateMaskedInputInner}
				absoluteHintPosition={props.absoluteHintPosition}
			/>

			{!!props.datePicker && (
				<Dialog open={props.datePicker.isOpenDatePicker} onClose={props.datePicker.onCloseDatePicker}>
					<Datepicker
						openDate={props.datePicker.openDate}
						selectedDates={props.datePicker.selectedDates}
						minDate={props.datePicker.minDate}
						maxDate={props.datePicker.maxDate}
						onSelect={props.datePicker.onSelect}
					/>
				</Dialog>
			)}
		</>
	);
};
